import { writeConfigFields } from './settings-fields';

/**
 * `PATCH /client/config/fields {task_pause_reasons}`: replaces the list.
 */
export const editTaskPauseReasons = async (reasons: string[]): Promise<any> => {
  return writeConfigFields({ task_pause_reasons: reasons });
};
